export const widths = {
  header: 60,
  helpColumn: 24,
  maxLine: 80
} as const;
